var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCategoryBuild({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.58 4.889H22.005v13.766l22.575-3.763V4.89zm49.7 93.575V33.29H57.505v65.175H51.68v-78.85l-36.775 6.13v72.72H4.889v5.825h99.407v-5.825H94.28zm-14.381-56.8h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm-14.2-42.6h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm-28.4-56.8h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm-14.2-28.4h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm0 14.2h6.187v5.825h-6.187v-5.825zm.181 14.2h20.025v14.2H37.48V90.09h-8.375v8.375H23.28v-14.2z",
    fill: "#E3E3E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryBuild);
export default __webpack_public_path__ + "static/media/category-build.00c9fc83cc386091f18200af4dd1b51a.svg";
export { ForwardRef as ReactComponent };